/* Top5CardsSection.tsx */
import React, {useEffect, useState, FC} from 'react'
import {API_URL} from '../../../modules/auth/core/_requests'
import RunawayButton from '../../../../_designereyes/partials/easter/runaway-button'

const GetShopifyFinancialData: FC = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [onlyAfterPay, setOnlyAfterPay] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    // Validate dates first
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    // If validation passes, proceed with download
    handleDownloadExcel();
  };

  const handleDownloadExcel = async () => {
    setLoading(true);

    try {
      let url = `${API_URL}/api/shopify-order-finance-data?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
      
      if (onlyAfterPay) {
        url += '&only_afterpay=true';
      }

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'shopify_financial_data.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
      alert("An error occurred while downloading the file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='card'>
      <div className='card-header d-flex flex-column flex-md-row justify-content-between align-items-md-center  pt-3'>
        <h3 className='card-title mb-2 mb-md-0'>Shopify Order Financial Data</h3>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <input
            type="checkbox"
            id="onlyAfterPay"
            checked={onlyAfterPay}
            onChange={(e) => setOnlyAfterPay(e.target.checked)}
          />
          <label htmlFor="onlyAfterPay" className="ms-2">Only AfterPay Orders</label>
        </div>

        <div className="row gy-3">
          <div className="col-md-4">
            <label htmlFor="startDate" className="form-label">Start Date</label>
            <input
              type="date"
              id="startDate"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="endDate" className="form-label">End Date</label>
            <input
              type="date"
              id="endDate"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div className="col-md-4 d-flex align-items-end">
            <RunawayButton 
              disabled={loading}
              onClick={handleDownload}
            >
              {loading ? "Downloading..." : "Download Excel"}
            </RunawayButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetShopifyFinancialData
